export default __webpack_public_path__ + "static/media/health_check_Cn.d6bd2f11.webp";